import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PrivacyPolicyPro from './pages/PrivacyPolicyPro';
import License from './pages/License';
import Features from './pages/Features';
import Setup from './pages/Setup';
import Troubleshooting from './pages/Troubleshooting';
import Download from './pages/Download';
import PatchNotes from './pages/PatchNotes';
import ContactPage from './pages/ContactPage';
import Upgrade from './pages/Upgrade';
import FAQ from './pages/FAQ';
import DeletePage from './pages/DeletePage';
import ScrollToTop from './components/ScrollToTop';


// Import other pages here

const App: React.FC = () => {
  return (
    <Router basename="/deckhopper">
      <ScrollToTop />
      <div className=" w-full min-h-screen text-gray-300">
        <Header />
        <div className="relative flex justify-center items-center mx-auto top-[65px] lg:top-[95px]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/index.html" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy-pro" element={<PrivacyPolicyPro />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/license.html" element={<License />} />
            <Route path="/license" element={<License />} />
            <Route path="/features" element={<Features />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/troubleshooting" element={<Troubleshooting />} />
            <Route path="/download" element={<Download />} />
            <Route path="/patch-notes" element={<PatchNotes />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/support" element={<ContactPage />} />
            <Route path="/upgrade" element={<Upgrade />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/datadeletion" element={<DeletePage />} />

          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
